import store from "./store";
import {IS_LIXIL_PRODUCTION} from "./config";
import {isIframe} from "./misc/helpers";

function isAnalytics() {
  return (typeof window.ga !== 'undefined');
}

function isMixPanel() {
  return (typeof window.mixpanel !== 'undefined');
}

function isGtag() {
  return (typeof window.gtag !== 'undefined')
}

const Analytics = {
  sendEvent: function(action, label, data) {
    if(window.analyticsDebugging)
      console.log('analytics tracking', action, label, data);
    if(isAnalytics()) {
      ga('send', 'event', 'bathroom-visualizer', action, label);
    }
    if(isGtag()) {
      gtag('event', action, {
        'event_category': 'visualizer',
        'event_label': label
      });
    }
    if(isMixPanel()) {
      mixpanel.track(action, {
        source: 'bathroom-visualizer',
        label: label,
        shareUrl: window.shareUrl,
        domain: window.location.host,
        ...data
      });
    }
    return true;
  },
  sendPageEvent: function(label, data) {
    return this.sendEvent('page-change-to', label, data);
  },
  sendDataEnteredEvent: function(label, data) {
    return this.sendEvent('data-entered', label, data);
  },
  sendClickEvent: function(label, data) {
    const {isMobile} = store.getState().serverState;
    if (isMobile) {
      label = `mobile-${label}`;
    }
    console.log("label", label);
    return this.sendEvent('clicked-on', label, data);
  },
  sendEcommerceEvent: function(action, data) {
    if (!IS_LIXIL_PRODUCTION) {
      return false
    }
    console.log("analytics ecommerce event:", action, data);
    if (window.gtag) {
      window.gtag('event', action, data); // https://support.google.com/analytics/answer/9267735#online-sales
    }
    return true;
  },
  setUserId: function(userId) {
    if(isAnalytics()) {
      ga('set', 'userId', userId);
    }
  },
  setMixPanelPerson: function(email, name, phone) {
    if(isMixPanel()) {
      if(window.analyticsDebugging)
        console.log('set mixpanel identity', email, name, phone);
      mixpanel.alias(email);
      mixpanel.identify(email);
      mixpanel.people.set({'$email': email, '$created': new Date(),'$name': name, '$phone':phone});
    }
  },
  setExistingMixPanelPerson: function(email) {
    if(isMixPanel()) {
      if(window.analyticsDebugging)
        console.log("set existing mixpanel identity");
      mixpanel.identify(email);
    }
  },
  logOutMixPanel: function() {
    if(window.analyticsDebugging)
      console.log('reset mixpanel identity', email, name, phone);
    if(isMixPanel()) {
      mixpanel.reset();
    }
  },
  sendParentPostMessage: function (action) {
    if (!isIframe() || !window.parent) {
      return
    }
    const {country, email, firstName, phoneNumber, postal} = store.getState().userState.userInfo;
    window.parent.postMessage({
      action,
      payload: {country, email, firstName, phoneNumber, postal},
    }, "*");
  },
  getSkuForAnalytics: function(feature, withPartId = true) {
    const sku = feature.dbFeature.sku || feature.dbFeature.sharedFeatureName;
    return withPartId
      ? feature.partId + "-" + sku.replace(/ /gi, "_")
      : sku.replace(/ /gi, "_")
  },
  getStringForAnalytics: function(string = "") {
    return string.replace(/ /gi, "_")
  },
}

export const QKB_ANALYTIC_EVENTS = {
  quotingToolWizardSwitch: "quotingtool-wizard-switch-",
  bodyPanelMatchAll: "visualizer-match-all-switch-",
}

export const LOOK_JOURNEY_ANALYTIC_EVENTS = {
  lookExit: "look-exit",
  lookCartButton: "look-cart-button",
  lookSidebarHome: "look-sidebar-home",
  lookSidebarFilters: "look-sidebar-filters",
  lookSidebarEdit: "look-sidebar-edit",
  lookSidebarRooms: "look-sidebar-rooms",
  lookSidebarPingPilot: "look-sidebar-ping-pilot",
  lookSidebarMobileAi: "look-sidebar-mobile-ai",
  lookSidebarSave: "look-sidebar-save",
  lookSidebarMore: "look-sidebar-more",
  lookSidebarShare: "look-sidebar-share",
  lookSidebarReset: "look-sidebar-reset",
  lookSidebarFacebook: "look-sidebar-facebook",
  lookSidebarTwitter: "look-sidebar-twitter",
  lookSidebarPinterest: "look-sidebar-pinterest",
  lookSidebarFeatureGroup: "look-sidebar-feature-group-",
  lookFooterExpandMenu: "look-footer-expand-menu",
  lookFooterCloseMenu: "look-footer-close-menu",
  lookMenuHeaderClose: "look-menu-header-close",
  lookMenuHeaderBack: "look-menu-header-back",
  lookMenuHeaderViewType: "look-menu-header-view-type-",
  lookFooterList: "look-footer-your-list",
  lookZoomPlus: "look-zoom-plus",
  lookZoomMinus: "look-zoom-minus",
  lookCanvasLayer: "look-canvas-layer-",
  lookCanvasContextMenu: "look-canvas-context-menu-",
  lookCanvasContextMenuItem: "look-canvas-context-menu-item-",
  lookCanvasDemoPoint: "look-canvas-demo-point-",
  lookFeatureImageChangeLeft: "look-feature-image-change-left",
  lookFeatureImageChangeRight: "look-feature-image-change-right",
  lookFeature3dAndArOpen: "look-feature-3d-and-ar-open",
  lookFeature3dAndArClose: "look-feature-3d-and-ar-close",
  lookFeatureMoreInfoOpen: "look-feature-more-info-open",
  lookFeatureMoreInfoClose: "look-feature-more-info-close",
  lookFeatureInfoContentHeaderClose: "look-feature-info-content-header-close",
  lookFeatureInfoContent3dAr: "look-feature-info-content-3d-ar",
  lookFeatureInfoContentSwitch: "look-feature-info-content-switch-",
  lookFeatureInfoContentFeatureLink: "look-feature-info-content-feature-link-",
  lookFeatureInfoContentAccordionOpen: "look-feature-info-content-accordion-open-",
  lookFeatureInfoContentAccordionClose: "look-feature-info-content-accordion-close-",
  lookFeatureChange: "look-feature-change",
  lookFeatureUnlock: "look-feature-unlock",
  lookFeatureRemove: "look-feature-remove-",
  lookFeatureEnable: "look-feature-enable-",
  lookFeatureConfirmChange: "look-feature-confirm-change",
  lookFeatureOptions: "look-feature-options-",
  lookFeatureMatchColorsCheckbox: "look-feature-match-colors-checkbox-",
  lookFeatureMobile3dButton: "look-feature-mobile-3d-button",
  lookFeaturesListDesignRecommended: "look-features-list-design-recommended-",
  lookFeaturesList: "look-features-list-",
  lookFeaturesFiltersClose: "look-features-filters-close",
  lookFeaturesFiltersReset: "look-features-filters-reset",
  lookFeaturesFiltersAccordionOpen: "look-features-filters-filter-group-open-",
  lookFeaturesFiltersAccordionClose: "look-features-filters-filter-group-close-",
  lookFeaturesFiltersValueChecked: "look-features-filters-filter-value-checked-",
  lookFeaturesFiltersValuerUnChecked: "look-features-filters-filter-value-unchecked-",
  lookOverlayLeave: "look-overlay-leave",
  lookOverlaySave: "look-overlay-save",
  lookPopupLogin: "look-popup-login",
  lookRoom: "look-room-",
  lookLeadCapturePopupLogin: "look-lead-capture-popup-login",
  lookLeadCapturePopupRegister: "look-lead-capture-popup-register",
  lookLeadCapturePopupForgotPassword: "look-lead-capture-popup-forgot-password",
  lookLeadCapturePopupTwoFAResendCode: "look-lead-capture-popup-two-fa-resend-code",
  lookLeadCapturePopupTwoFAReceiveCall: "look-lead-capture-popup-two-fa-receive-call",
  lookLeadCapturePopupTwoFAUpdatePhone: "look-lead-capture-popup-two-fa-update-phone",
  lookMobileActiveFeatureButton: "look-mobile-active-feature-button",
  lookMobileListClose: "look-mobile-list-close",
  lookIntroLearnToUse: "look-intro-learn-to-use",
  lookIntroStartDesign: "look-intro-start-design",
  lookIntroSkip: "look-intro-skip-on-step-",
  lookIntroFinalStepStartDesign: "look-intro-final-step-start-design",
  lookIntroPagination: "look-intro-pagination-",
  lookIntroNextStep: "look-intro-next-step-",
  lookRoomIdeasOnIntro: "look-room-ideas-on-intro",
  lookRoomIdeasOpen: "look-room-ideas-open",
  lookRoomIdeasClose: "look-room-ideas-close",
  lookRoomIdeasPreset: "look-room-ideas-preset-",
  lookMainCategory: "look-main-category-",
  lookCanvasPolicyLinks: "look-canvas-policy-links-",
  lookListPolicyLinks: "look-list-policy-links-",
  lookListHeaderSave: "look-list-header-save",
  lookListBackToCustomize: "look-list-back-to-customize",
  lookListAddToCart: "look-list-add-to-cart",
  lookListOpenMiniCart: "look-list-open-mini-cart",
  lookListSelectAllItems: "look-list-select-all-items-",
  lookListCartItemSelect: "look-list-cart-item-",
  lookListCartItemQuantityChange: "look-list-cart-item-quantity-",
  lookListCartItemRemove: "look-list-cart-item-remove-",
  lookListCartItemMoreDropdown: "look-list-cart-item-more-dropdown-",
  lookListCartItemMoreDropdownWishlist: "look-list-cart-item-more-dropdown-wishlist-",
  lookListCartItemMoreDropdownChange: "look-list-cart-item-more-dropdown-change-",
  lookStylePopupConfirmRemove: "look-style-popup-confirm-remove",
  lookStylePopupRemoveBackContinue: "look-style-popup-remove-back-continue",
  lookStylePopupRemoveBack: "look-style-popup-remove-back",
  lookStylePopupConfirm: "look-style-popup-confirm",
  lookPopupSaveSuccessSubmit: "look-popup-save-success-submit",
  lookPopupSaveResetSubmit: "look-popup-reset-submit",
  lookPopupChangeViewSubmit: "look-popup-change-view-submit",
  lookMenuWizard: "look-menu-wizard-",
  lookWizardParent: "look-wizard-parent-",
  lookWizardListFeature: "look-wizard-list-feature-",
  lookWizardListFilter: "look-wizard-list-filter-",
  lookWizardMatchAll: "look-wizard-match-all-",
  lookWizardCompletedClose: "look-wizard-completed-close",
  lookShowCompatabilityAlert: "look-show-compatability-alert",
  lookCloseCompatabilityAlert: "look-close-compatability-alert",
  lookCloseAndApplyCompatabilityAlert: "look-close-and-apply-compatability-alert",
  lookLockedButton: "look-locked-button",
  lookSidebarRevertCtrlZ: "look-sidebar-revert-or-ctrl-z",
  lookSidePanelAIClicked: "look-side-panel-ai-clicked",
}

export const PRODUCT_JOURNEY_ANALYTIC_EVENTS = {
  productTopButtonsShop: "product-top-buttons-shop",
  productTopButtonsExit: "product-top-buttons-exit",
  productTopButtonsMenu: "product-top-buttons-menu",
  productTopButtonsShare: "product-top-buttons-share-",
  productTopButtonsPingPilot: "product-top-buttons-ping-pilot",
  productTopButtonsShareFacebook: "product-top-buttons-share-facebook",
  productTopButtonsShareTwitter: "product-top-buttons-share-twitter",
  productTopButtonsSharePinterest: "product-top-buttons-share-pinterest",
  productTopButtonsSave: "product-top-buttons-save",
  productCanvasLayer: "product-canvas-layer-",
  productCanvasContextMenu: "product-canvas-context-menu-",
  productCanvasContextMenuItem: "product-canvas-context-menu-item-",
  productCanvasDemoPoint: "product-canvas-demo-point-",
  productSidebarHeaderAllProducts: "product-sidebar-header-all-products",
  productSidebarHeaderRoomLayouts: "product-sidebar-header-room-layouts",
  productSidebarHeaderCart: "product-sidebar-header-cart",
  productSidebarCategory: "product-sidebar-category-",
  productFeatureChange: "product-feature-change",
  productFeatureImageChangeLeft: "product-feature-image-change-left",
  productFeatureImageChangeRight: "product-feature-image-change-right",
  productFeatureMoreInfoOpen: "product-feature-more-info-open",
  productFeatureMoreInfoClose: "product-feature-more-info-close",
  productFeatureInfoContentAccordionOpen: "product-feature-info-content-accordion-open-",
  productFeatureInfoContentAccordionClose: "product-feature-info-content-accordion-close-",
  productFeatureQuantityChange: "product-feature-quantity-change",
  productFeatureRemove: "product-feature-remove-",
  productFeatureEnable: "product-feature-enable-",
  productFeature3dAndArOpen: "product-feature-3d-and-ar-open",
  productFeature3dAndArClose: "product-feature-3d-and-ar-close",
  productFeatureInfoContentHeaderClose: "product-feature-info-content-header-close",
  productFeatureInfoContent3dAr: "product-feature-info-content-3d-ar",
  productFeatureInfoContentSwitch: "product-feature-info-content-switch-",
  productFeatureInfoContentFeatureLink: "product-feature-info-content-feature-link-",
  productFeatureUnlockNow: "product-feature-unlock-now",
  productFeatureLockedBadge: "product-feature-locked-badge",
  productFeatureLocked3DButton: "product-feature-locked-3d-button",
  productFeatureSQFT: "product-feature-sqft",
  productFeatureAddToCart: "product-feature-add-to-cart-",
  productFeatureContinueShopping: "product-feature-continue-shopping",
  productFeatureCloseProductsList: "product-feature-close-features-list",
  productFeatureOptions: "product-feature-options-",
  productFeatureMobile3dButton: "product-feature-mobile-3d-button",
  productFeaturesNext: "product-features-next-",
  productFeaturesList: "product-features-list-",
  productFeaturesListViewType: "product-features-list-view-type-",
  productFeaturesFiltersClose: "product-features-filters-close",
  productFeaturesFiltersReset: "product-features-filters-reset",
  productFeaturesFiltersAccordionOpen: "product-features-filters-filter-group-open-",
  productFeaturesFiltersAccordionClose: "product-features-filters-filter-group-close-",
  productFeaturesFiltersValueChecked: "product-features-filters-filter-value-checked-",
  productFeaturesFiltersValuerUnChecked: "product-features-filters-filter-value-unchecked-",
  productSimilarListClose: "product-similar-list-close",
  productSimilarListTitle: "product-similar-list-title",
  productSimilarListFeature: "product-similar-list-feature-",
  productSimilarListFeatureAddToCart: "product-similar-list-feature-add-to-cart-",
  productOverlayLeave: "product-overlay-leave",
  productOverlaySave: "product-overlay-save",
  productPopupLogin: "product-popup-login",
  productMatchColorsVisualizeAllCheckbox: "product-match-colors-visualize-all-checkbox-",
  productRoom: "product-room-",
  productRoomLayouts: "product-room-layouts",
  productRoomIdeas: "product-room-ideas",
  productRoomIdeasPreset: "product-room-ideas-preset-",
  productFiltersOpen: "product-filters-open",
  productMenuFooterButton: "product-menu-footer-button",
  productPopupSaveSuccessSubmit: "product-popup-save-success-submit",
  productPopupResetSubmit: "product-popup-reset-submit",
  productPopupChangeViewSubmit: "product-popup-change-view-submit",
  roomsRoomLayouts: "rooms-room-layouts",
  roomsRoomIdeas: "rooms-room-ideas",
  cartCheckoutLogin: "cart-checkout-login",
  cartCheckoutRegister: "cart-checkout-register",
  cartCheckoutSuccessContinueShopping: "cart-checkout-success-continue-shopping",
  cartCheckoutSuccessViewAll: "cart-checkout-success-view-all-",
  cartCheckoutSuccessFeature: "cart-checkout-success-feature-",
  cartTermsAccept: "cart-terms-accept",
  cartTwoFANext: "cart-two-fa-next",
  cartTwoFAUpdatePhone: "cart-two-fa-update-phone",
  cartTwoFAResendCode: "cart-two-fa-resend-code",
  cartTwoFAReceiveCall: "cart-two-fa-receive-call",
  leadCapturePopupLogin: "lead-capture-popup-login",
  leadCapturePopupRegister: "lead-capture-popup-register",
  leadCapturePopupForgotPassword: "lead-capture-popup-forgot-password",
  leadCapturePopupTwoFAResendCode: "lead-capture-popup-two-fa-resend-code",
  leadCapturePopupTwoFAReceiveCall: "lead-capture-popup-two-fa-receive-call",
  leadCapturePopupTwoFAUpdatePhone: "lead-capture-popup-two-fa-update-phone",
  productLockedButton: "product-locked-button",
  shopFeaturesList: "shop-features-list-",
  shopFeaturesListOptions: "shop-features-list-options-",
  shopFeatureOptions: "shop-feature-options-",
  shopFeatureAddToCart: "shop-feature-add-to-cart-",
  shopHelpChat: "shop-help-chat",
  shopSQFTButton: "shop-feature-sqft",
}

export default Analytics
